export default __webpack_public_path__ + "static/media/single-01-entrance-inactive.eeaecba7.webp";